import React from "react";
import { Breadcrumb as AntdBreadcrumb, type BreadcrumbProps,  } from "antd";
import "./style.scss";

interface Props {
  items: BreadcrumbProps["items"];
}

const Breadcrumb: React.FC<Props> = ({ items }) => {
  return <AntdBreadcrumb items={items} />;
};

export default Breadcrumb;
